<template>
  <b-modal
    modal-class="component-modal-product"
    id="mrpDetailModal"
    ref="mrpDetailModal"
    size="xl"
    title="เอกสารอ้างอิงการขอซื้อ (MRP)"
    no-close-on-backdrop
    scrollable
    @close="close"
    @hidden="mrpDetail = null"
  >
    <div
      v-if="mrpDetail"
      class="grid-modal"
    >
      <div class="layout-modal-left">
        <div class="layout-row">
          <div class="layout-row-item-label">เลขที่เอกสาร:</div>
          <div class="layout-row-item-value">{{ mrpDetail.no }}</div>
        </div>
        <div class="layout-row">
          <div class="layout-row-item-label">วันที่ทำรายการ:</div>
          <div class="layout-row-item-value">
            {{ formatDate(mrpDetail.creationDt) }}
          </div>
        </div>
        <div class="layout-row">
          <div class="layout-row-item-label">ชื่อสาขา:</div>
          <div class="layout-row-item-value">{{ mrpDetail.branchName }}</div>
        </div>
      </div>
      <div class="layout-modal-right">
        <b-table
          id="mrpDetailTable"
          hover
          small
          head-variant="light"
          :items="productsWithImages"
          :fields="fields"
          :filter="filter"
          :sort-desc="true"
          :responsive="true"
        >
          <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>
          <template v-slot:cell(image)="row">
            <ProductImage :src="row.item.imageUrl" />
          </template>
          <template v-slot:cell(productNo)="row">
            {{ row.item.no }}
          </template>
          <template v-slot:cell(productName)="row">
            {{ row.item.description }}
          </template>
          <template v-slot:cell(productQty)="row">
            {{ formatProductStock(row.item.quantity) }}
          </template>
          <template v-slot:cell(productUnit)="row">
            {{ row.item.uom.description }}
          </template>
        </b-table>
      </div>
    </div>

    <template v-slot:modal-footer>
      <b-button
        variant="primary"
        @click="$emit('convert', mrpDetail)"
      >
        แปลงเป็นใบขอซื้อ
      </b-button>
    </template>

    <Loading v-if="isLoading"></Loading>
  </b-modal>
</template>

<script>
import Loading from "@/components/Loading";
import "@/theme/modal/ProductAndStock/Product.scss";
import moment from "moment";
import ProductImage from "@/components/table/stock/component/ProductImage.vue";
import { mapGetters } from "vuex";

export default {
  name: "MrpDetailModal",
  components: {
    Loading,
    ProductImage,
  },
  data() {
    return {
      isLoading: false,
      mrpDetail: null,
      filter: null,
      fields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "5%" },
          tdStyle: { width: "5%" },
        },
        {
          key: "image",
          label: "",
          thStyle: { width: "5%" },
        },
        {
          key: "productNo",
          label: "รหัส",
          thStyle: { width: "18%" },
          tdStyle: { width: "18%" },
        },
        {
          key: "productName",
          label: "ชื่อสินค้า",
          thStyle: { width: "39%" },
          tdStyle: { width: "39%" },
        },
        {
          key: "productQty",
          label: "จำนวนสินค้า",
          thStyle: { width: "19%" },
          tdStyle: { width: "19%" },
          class: "text-right",
        },
        {
          key: "productUnit",
          label: "หน่วยสินค้า",
          thStyle: { width: "19%" },
          tdStyle: { width: "19%" },
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getProductList: "moduleProductInventory/getProductList",
    }),
    productsWithImages() {
      if (!this.mrpDetail?.products) return [];
      return this.mrpDetail.products.map(p => ({
        ...p,
        imageUrl:
          this.getProductList.find(
            pl =>
              pl.productId === p.productId ||
              pl.productCode === p.no ||
              pl.productCode === p.productCode
          )?.imageUrl || null,
      }));
    },
  },
  methods: {
    show(mrpDetail) {
      this.mrpDetail = mrpDetail;
      this.$bvModal.show("mrpDetailModal");
    },
    close() {
      this.$bvModal.hide("mrpDetailModal");
    },
    formatDate(date) {
      return date ? moment(date).locale("th").format("D MMM YY") : "";
    },
    formatProductStock(value) {
      if (value === null || value === "") return "";
      const num = Number(value);
      if (Number.isNaN(num)) return "";
      return num.toLocaleString("en-US");
    },
  },
};
</script>

<style scoped>
.grid-modal {
  display: grid;
  grid-template-columns: 30% 70%;
}

.layout-modal-left {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-right: 1px solid #dee2e6;
  padding-right: 16px;
}

.layout-modal-right {
  padding-left: 16px;
}

.layout-row {
  display: flex;
  gap: 8px;
}

@media (max-width: 750px) {
  .layout-row {
    flex-direction: column;
  }
}

.layout-row-item-label {
  font-weight: 600;
  color: #212529;
  white-space: nowrap;
}

.layout-row-item-value {
  font-weight: 400;
  color: #212529;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

::v-deep .modal-body {
  padding: 16px 24px 24px 24px !important;
}

::v-deep #mrpDetailTable tbody tr td {
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #mrpDetailTable thead tr th,
::v-deep #mrpDetailTable tbody tr td {
  vertical-align: middle !important;
  border-bottom: 1px solid #dee2e6;
}
</style>
